// EN
export const hotelRatesManager = {
  perNight: "/ night",
  roomFallback: "Room #{id}",

  header: {
    eyebrow: "Main rates",
    title: "Hotel rates",
    subtitle:
      "Create base rates and apply them to one or more rooms. Derived rates sync with the channel manager.",
    newMain: "New main rate",
  },
  states: {
    loading: "Loading rates…",
    emptyTitle: "No rates yet",
    emptySubtitle:
      "Create the first main rate to start managing prices and syncing with the channel manager.",
    createFirst: "Create first rate",
  },
  card: {
    mainBadge: "Main",
    occupancy: "Occ. {count}",
    minStay: "Min. {count} night | Min. {count} nights",
    editRate: "Edit rate",
    deleteRate: "Delete rate",
    rooms: "Rooms",
    syncedTooltip: "Synced with channel manager",
    removeSyncedTooltip: "Remove (warning: channel manager)",
    removeRoomTooltip: "Remove from this room",
    add: "Add",
    selectRoom: "Select room",
    derivedBadge: "Derived",
    derivedFrom: "from {name}",
    sameNameHint: "There is another “{name}” with a different price or conditions. Each card is edited separately.",
    editDerived: "Edit derived",
    deleteDerived: "Delete derived",
  },
  derived: {
    toggle: "Derived rates",
    empty:
      "No derived rates yet. Create one for Booking.com, Airbnb or specific OTAs.",
    newDerived: "New derived rate",
  },
  common: {
    allRooms: "all rooms",
    cancel: "Cancel",
    saving: "Saving…",
    creating: "Creating…",
    saveChanges: "Save changes",
    removeAll: "Clear all",
  },
  mainModal: {
    editTitle: "Edit main rate",
    newTitle: "New main rate",
    nameLabel: "Name",
    namePlaceholder: "E.g. Standard rate, Weekend…",
    priceLabel: "Price per night",
    occupancyLabel: "Occupancy",
    minStayLabel: "Minimum stay (nights)",
    maxStayLabel: "Maximum stay (nights)",
    validityLabel: "Validity",
    permanent: "Permanent",
    dateRange: "Date range",
    from: "From",
    to: "To",
    descriptionLabel: "Description (optional)",
    descriptionPlaceholder: "Internal notes about this rate…",
    searchPlaceholder: "Search room…",
    selectAllShort: "All",
    noResults: 'No results for "{query}"',
    noRoomsAvailable: "No rooms available",
    editInfo: "Changes will apply to {rooms} in this card.",
    createRate: "Create rate",
  },
  derivedModal: {
    editTitle: "Edit derived rate",
    newTitle: "New derived rate",
    subtitle: "Derived from {name} · {price}",
    nameLabel: "Derived rate name",
    namePlaceholder: "E.g. Booking.com, Airbnb, No breakfast…",
    nameHint: "This name identifies the rate in the channel manager.",
    adjustTypeLabel: "Adjustment type",
    percentage: "Percentage",
    fixedAmount: "Fixed amount",
    adjustValueLabel: "Adjustment value",
    adjustValueHint: "(negative = discount)",
    resultPriceLabel: "Resulting price",
    baseLabel: "Base",
    applyToRooms: "Apply to rooms",
    onlyMainRooms: "Only rooms that have the main rate are shown.",
    noRoomsWithMain: "The main rate isn't applied to any room yet.",
    selectAll: "Select all",
    editInfo:
      "Editing will update the adjustment on {rooms} that have this derived rate.",
    createDerived: "Create derived",
  },
  removeModal: {
    title: "Remove from room",
    syncWarnTitle: "This rate is synced with the channel manager",
    syncWarnBody:
      "Removing it may {break} of rates in Channex for this room. Check the channel manager before continuing.",
    syncWarnBreak: "break the sync",
    confirmText: "This action will remove the rate {rate} from room {room}.",
    roomLabel: "Room",
    rateLabel: "Rate",
    statusLabel: "Status",
    syncedWithChannex: "Synced with Channex",
    removing: "Removing…",
    removeAnyway: "I understand, remove anyway",
    confirm: "Remove from room",
  },
  deleteModal: {
    title: "Delete rate",
    warnTitle: "This action can't be undone",
    warnBody: "The rate {rate} will be removed from {rooms}.",
    roomsCount: "{count} room | {count} rooms",
    syncedWarn:
      "Some rooms are synced with Channex. This may affect rate syncing.",
    confirmLabel: "Type {name} to confirm",
    deleting: "Deleting…",
    confirm: "Delete permanently",
  },
  toasts: {
    loadError: "Error loading the hotel rates",
    mainCreated: "Rate created in {count} room | Rate created in {count} rooms",
    createdPartial: "{ok} created, {fail} failed",
    mainCreateFailAll: "Couldn't create the rate in any room",
    mainUpdated: "Rate updated",
    updatedPartial: "{ok} updated, {fail} failed",
    mainUpdateFail: "Couldn't update the rate",
    derivedCreated:
      "Derived rate created in {count} room | Derived rate created in {count} rooms",
    derivedCreateFail: "Couldn't create the derived rate",
    derivedUpdated: "Derived rate updated",
    derivedUpdateFail: "Couldn't update the derived rate",
    roomAddedMain: "Rate added to {room}",
    addRateError: "Error adding the rate",
    noMainRate: "This room doesn't have the main rate. Add it first.",
    roomAddedDerived: "Derived rate added to {room}",
    addDerivedError: "Error adding the derived rate",
    rateRemoved: "Rate removed from {room}",
    removeError: "Error removing the rate",
    rateDeleted: "Rate deleted",
    deletedPartial: "{ok} deleted, {fail} failed",
    deleteError: "Error deleting",
  },
  errors: {
    invalidRange: "Select a valid date range",
    startAfterEnd: "The start date can't be later than the end date",
    minStayRange: "Minimum stay: {minStay} nights, but the range has {nights}",
  },
};
